import Vue from 'vue'
import Layout from './Layout'
import LayoutHeader from './LayoutHeader'
import LayoutBody from './LayoutBody'
import LayoutFooter from './LayoutFooter'

Vue.component('AppLayout', Layout)
Vue.component('AppLayoutHeader', LayoutHeader)
Vue.component('AppLayoutBody', LayoutBody)
Vue.component('AppLayoutFooter', LayoutFooter)
